
export const formIsComplete = obj => {
    if ((typeof obj) != 'object') {
        console.log(" 'formIsComplete' an requires object as input")
        return false
    }

    const formValues = Object.values(obj)
    console.log("obj",obj);
    for (let i = 1; i < formValues.length; i++)
        if (!Boolean(formValues[i])){
          console.log("not done",formValues[i]);
           return false
        }
    return true
}

export const isAuthenticated = () => {
    const hominem = localStorage.getItem("hominem");
    if (hominem) {
        const user = JSON.parse(atob(hominem));
        const now = new Date().getTime();
        const ONE_FULL_DAY_IN_MILLISECONDS = 86400000;
        if (now - user.tempus > ONE_FULL_DAY_IN_MILLISECONDS) return false;
        else return true;
    } else return false;
}

export const getAppBarHeading = (pathname, heading = "") => {
    switch (pathname) {
      case "/":
        heading = "Dashboard";
        break;
      case "/worklist":
        heading = "Worklist Screen";
        break;
      case "/patient":
        heading = "Create Patient";
        break;
      case "/edit-patient":
        heading = "Edit Patient";
        break;
      case "/users":
        heading = "User List";
        break;
      case "/procedures":
        heading = "Procedure List";
        break;
      case "/branches":
        heading = "Branch List";
        break;
      case "/study":
        heading = "Study Screen";
        break;
      case "/scheduling":
        heading = "Schedule Screen";
        break;
      case "/reporting":
        heading = "Reporting Page";
        break;
      case "/pacs":
        heading = "Pacs Screen";
        break;
    }

    return heading;
  };